import React, { useState, useEffect } from "react"
import DailyView from "../schedule/DailyView"
import { ReactComponent as Slant } from "../schedule/images/slant_header.svg"
import { ReactComponent as JFilmWatermark } from "../schedule/images/watermark_jfilm--slice.svg"
import { ReactComponent as ShortsWatermark } from "../schedule/images/watermark_pittsburgh_shorts--slice.svg"
import { ReactComponent as ThreeRiversWatermark } from "../schedule/images/watermark_3rff--slice.svg"
import { ReactComponent as FilmPittWatermark } from "../schedule/images/watermark_film_pittsburgh--slice.svg"

const ScheduleBlock = (props) => {
  const { ids, festival, heading, rowTitle } = props

  const [loadedEvents, setLoadedEvents] = useState([])
  const [eventTrackList, setEventTrackList] = useState([])
  const [ticketing, setTicketing] = useState([])
  const [ordering, setOrdering] = useState([])

  useEffect(() => {
    fetch(
      `/calendar.json?${new URLSearchParams({ event_ids: ids }).toString()}`,
    )
      .then((response) => response.json())
      .then((data) => {
        setLoadedEvents(data)

        let tracks = [...eventTrackList]

        data.forEach((event) => {
          tracks = tracks.concat(event.tracks)
        })

        setEventTrackList(tracks)

        fetch(`/ticketing.json`)
          .then((response) => response.json())
          .then((data) => {
            setTicketing(data)
          })

        fetch(`/events/ordered_tracks.json`)
          .then((response) => response.json())
          .then((data) => {
            setOrdering(data)
          })
      })
      .catch((error) => console.error(error))
  }, [])

  return (
    <div className="schedule-block">
      {heading && (
        <div className={`section-header ${festival}`}>
          <h1>{heading}</h1>

          <div className="slant-backdrop">
            <Slant />
          </div>

          <div className="section-header__watermark">
            {festival === "jfilm" ? (
              <JFilmWatermark />
            ) : festival === "pittsburgh_shorts" ? (
              <ShortsWatermark />
            ) : festival === "three_rivers_film_festival" ? (
              <ThreeRiversWatermark />
            ) : (
              <FilmPittWatermark />
            )}
          </div>
        </div>
      )}
      <div className="schedule__inner">
        {loadedEvents.length > 0 ? (
          <DailyView
            title={rowTitle || "Film Pittsburgh"}
            topFestival={festival}
            events={loadedEvents}
            trackList={eventTrackList}
            filters={{
              date: null,
              track: "all",
              genre: "",
              venue: "",
            }}
            path=""
            screenings={[]}
            ticketing={ticketing}
            ordering={ordering}
          />
        ) : (
          <p className="empty-message">There are no upcoming events</p>
        )}
      </div>
    </div>
  )
}

export default ScheduleBlock
